import Masonry = require('masonry-layout');
import imagesLoaded = require('imagesloaded');

class Gallery {
  constructor() {
    this._init();
  }

  private _init(): void {
    const grids = document.querySelectorAll<HTMLElement>('.grid');

    grids.forEach((grid) => {
      const imgLoad = imagesLoaded(grid);

      // We wait for all images to be loaded ('always') before doing the final layout.
      // This ensures Masonry sees the final CSS-constrained dimensions (width: 100%) 
      // instead of the large natural dimensions of the images.
      imgLoad.on('always', () => {
        // A small delay (requestAnimationFrame) helps ensure the browser has finished
        // the reflow after images are marked as loaded.
        requestAnimationFrame(() => {
          new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            transitionDuration: '0.4s'
          });

          grid.classList.add('is-initialized');
        });
      });

      // Optional: perform a layout on progress if we want early feedback, 
      // but 'always' + delay is the most robust fix for the "white gaps" issue.
      imgLoad.on('progress', () => {
        // If we layout mid-progress, we might still get the white gaps temporarily.
        // For a perfectly tight grid, 'always' is safer.
      });
    });
  }
}

export const gallery = new Gallery();
